<template>
  <section class="sec-top-intro">
    <!-- <div class="top-recom">
      <img src="@/assets/img/mainimg-33.jpg" class="only_pc" />
      <img src="@/assets/img/sp-mainimg-33.jpg" class="only_sp" />
    </div> -->
    <div class="box-top-slide">
      <div class="img-top-slide">
        <div id="slide" class="img-top-slide-in">
          <figure class="item is-active"><a href="https://docs.google.com/viewer?url=https://www.manavis-cosme.co.jp/web/contents/library/pdf/campaign-information/2026_birthday_1.pdf"><img src="@/assets/img/banner_2026_birthday.jpg"></a></figure>
          <figure class="item"><a href="https://docs.google.com/viewer?url=https://www.manavis-cosme.co.jp/web/contents/library/pdf/campaign-information/2026_nyuukai.pdf"><img src="@/assets/img/banner_2026_nyuukai.jpg"></a></figure>
          <figure class="item"><a href="https://docs.google.com/viewer?url=https://www.manavis-cosme.co.jp/web/contents/library/pdf/campaign-information/2026_syoukai.pdf"><img src="@/assets/img/banner_2026_syoukai.jpg"></a></figure>
          <figure class="item"><a href="https://docs.google.com/viewer?url=https://www.manavis-cosme.co.jp/web/contents/library/pdf/product-description/bodymilk_pouch.pdf"><img src="@/assets/img/banner_bodymilk_pouch.jpg"></a></figure>
          <figure class="item"><router-link to="/lp/vitamin-d-plus"><img src="@/assets/img/top_slider_vitamin-d.jpg"></router-link></figure>
          <figure class="item"><router-link to="/lp/msc-seminar-2023"><img src="@/assets/img/msc_seminar_2023_banner_3.jpg"></router-link></figure>
        </div>
        <!-- ◯のナビを追加 -->
        <div id="slide-nav" class="slide-nav"></div>
      </div>
    </div>
  </section>

  <section>
    <div class="top_news" v-if="shopping">
      <h2>お知らせ</h2>
      <!-- <img src="@/assets/img/information.png" style="width: 100px" /> -->
      <!-- 最新10件表示 -->
      <div class="news_section">
        <dl class="list-news">
          <template v-for="(info, i) in informationsForShopping" :key="i">
            <dt>{{ info.date }}</dt>
            <dd v-html="info.html" />
          </template>
        </dl>
      </div>
    </div>
    <div class="box-p-20 text-center" v-if="shopping">
      <router-link to="/archives" class="btn d-inline-block">
        過去記事一覧へ
      </router-link>
    </div>
    <div class="top_news" v-if="!shopping">
      <h2>会員通信</h2>
      <!-- <img src="@/assets/img/information.png" style="width: 100px" /> -->
      <!-- 最新10件表示 -->
      <div class="news_section">
        <dl class="list-news">
          <template v-for="(info, i) in informationsForGeneral" :key="i">
            <dt>{{ info.date }}</dt>
            <dd v-html="info.html" />
          </template>
        </dl>
      </div>
    </div>
    <div class="box-p-20 text-center" v-if="!shopping">
      <router-link to="/archives" class="btn d-inline-block">
        過去記事一覧へ
      </router-link>
    </div>

    <router-link to="/lp/album-202511"><img src="@/assets/img/album/album_bunner_202511.jpg" alt="202511" style="margin-top: 20px;" /></router-link>
    
    <div class="top_news" v-if="!shopping">
      <h2>ビューティーコラム</h2>
      <div class="column_section d-flex flex-wrap justify-content-between">
        <div class="column_item">
            <router-link to="/column/column-202603"><img src="@/assets/img/column/column_202603.png" alt="202603" /></router-link>
            <h3>スキンケア成分の選び方</h3>
            <p>肌荒れ・美白・保湿まで悩み別に解説【正式名称つき】</p>
            <div class="text-center mt-5">
              <router-link to="/column/column-202603" class="btn">
                コラムを読む
              </router-link>
            </div>
        </div>
        <div class="column_item">
            <router-link to="/column/column-202602"><img src="@/assets/img/column/202602_top.png" alt="202602" /></router-link>
            <h3>「老け見え」の原因は骨にあった？</h3>
            <p>整形外科医が警告する<br>顔の骨密度低下と<br>ビタミンDの深い関係</p>
            <div class="text-center mt-5">
              <router-link to="/column/column-202602" class="btn">
                コラムを読む
              </router-link>
            </div>
        </div>
        <div class="column_item">
            <router-link to="/column/column-202601"><img src="@/assets/img/column/column_202601.png" alt="202601" /></router-link>
            <h3>化粧水・美容液・乳液の正しい順番とは？</h3>
            <p>そして知りたい、美容液の選び方。「化粧水、美容液、乳液の順番って？」「美容液はいつ塗るの？」</p>
            <div class="text-center mt-5">
              <router-link to="/column/column-202601" class="btn">
                コラムを読む
              </router-link>
            </div>
        </div>
      </div>
    </div>
    <div class="box-p-20 text-center" v-if="!shopping">
      <a href="/web/contents/library/beauty-column/index.html" class="btn d-inline-block">
        過去記事一覧へ
      </a>
    </div>
  </section>
  
  <div class="top_libraly_bunner">
    <a href="/web/contents/library/index.html"><img src="@/assets/img/top_libraly.jpg" /></a>
  </div>

  <section class="app_get only_sp mt-5">
    <div class="d-flex justify-content-around">
      <img src="@/assets/img/appstore.png" alt="AppStore" />
      <img src="@/assets/img/google-play-badge.png" alt="GooglePlay" />
    </div>
  </section>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();

export default {
  data() {
    return {
      informations: [],
      informationsForManager: [],
      informationsForShopping: [],
      informationsForGeneral: [],
      shopping: true,
      timer:false,
    };
  },
  computed: {
    isManager() {
      return this.$store.state.isManager;
    },
    isManager_J(){
      return this.$store.state.isManager_J;
    }
  },
  mounted() {
    var today = new Date(Date.now());
    var targetDay = new Date(2022, 11, 29, 16 , 0, 0)
    console.log("now:"+today)
    console.log("targetDay:"+targetDay)
    this.timer = today > targetDay
    console.log("timer:"+this.timer)
    window.scroll(0, 0);
    this.shopping = auth.getShopping();
    axios
      .get(process.env.VUE_APP_CONTENTS_INFORMATION_HOME + "index.json?"+new Date().getTime())
      .then((res) => {
        let forManager = res.data.filter(function (info) {
          return (info.isManager);
        });
        let forShopping = res.data.filter(function (info) {
          return (info.isShopping);
        });
        let forGeneral = res.data.filter(function (info) {
          if(!(info.isManager || info.isShopping)) {
            return true;
          }else{
            return false;
          }
        });
        this.informationsForManager = forManager.slice(0, 3);
        this.informationsForShopping = forShopping.slice(0, 3);
        this.informationsForGeneral = forGeneral.slice(0, 3);
      })
      .catch(() => {
        console.log("お知らせが読み取れません");
      });
    $(function(){
        var imgs = $('#slide .item');
        var imgLen = imgs.length;
        var count = 0;
        var nav = $('#slide-nav');
        var timerId;

        nav.empty();

        // スライド切替関数
        function showSlide(index) {
          count = index % imgLen;
          imgs.removeClass('is-active').eq(count).addClass('is-active');
          nav.find('button').removeClass('active').eq(count).addClass('active');
        }
        // 自動切替関数
        function startTimer() {
          timerId = setInterval(function(){
            showSlide(count + 1);
          }, 2500);
        }

        // ナビ用ボタン生成
        imgs.each(function(i){
          var btn = $('<button>').on('click', function(){
            // スライド表示
            showSlide(i);

            // タイマーをリセット
            clearInterval(timerId);
            startTimer();
          });
          if(i === 0) btn.addClass('active');
          nav.append(btn);
        });

        // 最初のスライド＆タイマー開始
        showSlide(0);
        startTimer();
      });
  },
};
</script>

<style scoped>
/* トップMV */
.top-recom img {
  width: 100%;
  margin: 0 auto;
}
/* トップスライダー */
.box-top-slide .txt-top-slide {
  position: absolute;
  top: 120px;
  left: 50%;
  letter-spacing: 4px;
  line-height: 2;
  font-size: 30px;
  transform: translateX(-50%);
  z-index: 1;
}
.img-top-slide-in {
  position: relative;
}
.img-top-slide-in:before {
  content: "";
  display: block;
  padding-top: 56.25%;
}
.img-top-slide-in .item {
  opacity: 0;
  position: absolute;
  transition: opacity 1.5s ease-in-out;
  pointer-events: none;
  top: 0;
}
.img-top-slide-in .item.is-active {
  opacity: 1;
  pointer-events: auto;
}
.img-top-slide .item img {
  width: 100%;
  height: auto;
}
.sec-top-intro .txt-top-01,
.sec-top-intro .txt-top-02 {
  text-align: center;
}
.sec-top-intro .txt-top-01 {
  margin: 100px 0 40px;
  letter-spacing: 2px;
  font-size: 20px;
}
.sec-top-intro .txt-top-02 {
  margin-bottom: 20px;
  line-height: 2.28;
}

#slide-nav {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  gap: 8px;
}

/* 会員通信 */
.top_news {
  padding: 20px;
}
.top_news h2 {
  text-align: left;
  border-bottom: 1px solid #eee;
  margin-bottom: 0;
  line-height: 10vh;
  font-size: 35px;
}
.top_news img {
  width: 100px;
}
.top_news .btn {
  min-width: 130px;
}
.top_news .news_section {
  width: 100%;
}
.list-news dt {
  float: left;
  width: 120px;
  padding-top: 17px;
  letter-spacing: 0.1em;
  font-family: "proxima-nova", sans-serif;
}
.list-news dd {
  padding: 17px 0 17px 150px;
  border-bottom: 1px solid #eee;
}
/* トップカテゴリー */
.category_card {
  display: flex;
  flex-direction: column;
  width: 25%;
}
.category_card img {
  width: 100%;
}
.app_get {
  padding: 20px;
}
.app_get img {
  width: 50%;
  height: 100%;
}
.lineup_title {
  display: flex;
  align-items: center;
  height: 5vh;
  padding-left: 20px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  clear: both;
}

@media screen and (min-width: 1px) and (max-width: 991px) {
  .list-news dt {
    width: 100%;
  }

  .list-news dd {
    padding: 0 0 15px;
  }
  .top_news .btn {
    margin-top: 3rem;
  }
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .category_card {
    width: 50%;
  }
  .sec-top-intro {
    margin: 0 -15px;
  }
}

/* ビューティーコラム */
.column_section .column_item {
    width: calc(33.33% - 10px);
    text-align: center;
    padding-top: 17px;
}
.column_section .column_item h3 {
  margin: 15px 0;
}
.column_section .column_item img {
  width: 100% !important;
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_section .column_item {
      width: 100%;
      padding-bottom: 17px;
  }
}


/* ライブラリバナー */
.top_libraly_bunner {
  margin-top: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.top_libraly_bunner img {
  width: 300px;
}

@media screen and (min-width: 1px) and (max-width: 768px) {
  .top_libraly_bunner img {
    width: 100%;
  }
}

</style>
<style>
#slide-nav button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none !important;
  background-color: #ccc;
  cursor: pointer;
  transition: background-color 0.3s;
  padding: inherit;
}
#slide-nav button.active {
  background-color: #333 !important;
}
</style>